document.addEventListener('DOMContentLoaded', function () {
  if (!('IntersectionObserver' in window)) return;

  // ظهور السكاشن عند الوصول للشاشة (الهوم بيدج فقط)
  var sections = document.querySelectorAll('body.template-index .shopify-section');
  var sectionObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          sectionObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
  );
  sections.forEach(function (s) { sectionObserver.observe(s); });

  // ظهور متتابع لعناصر الكروت (البراندات، الآراء، المميزات...)
  var items = document.querySelectorAll('.reveal-item');
  var itemObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          itemObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  items.forEach(function (i) { itemObserver.observe(i); });

  // نبضة بصرية على أيقونة السلة عند الإضافة
  document.addEventListener('cart:updated', function () {
    var bubble = document.querySelector('.cart-count-bubble');
    if (!bubble) return;
    bubble.classList.add('is-updated');
    setTimeout(function () { bubble.classList.remove('is-updated'); }, 350);
  });
});
